import { HealthChart } from 'ui/HealthChart/HealthChart';
import { AssetCover } from '../AssetCover';
import PdfStatus from './PdfStatus';
import { ReportPDFReponse } from 'queries/report/contract';

type PdfSummaryProps = {
  data: ReportPDFReponse;
};

export const PdfSummary = ({ data }: PdfSummaryProps) => {
  return (
    <div className="pdf-top-margin">
      <div className="is-flex is-justify-content-space-between">
        <div className="pdf-summary-title">
          {data.name} - {data.description}
        </div>
      </div>

      <div className="pdf-summary-info mt-4">
        <AssetCover asset={{ id: data.id, name: data.name }} />

        {(data.health_score || data.health_score === 0) && (
          <HealthChart
            healthData={data.health_score.toFixed(0)}
            isGaussianLigth
            chartHeight="80px"
            className="pdf-summary-health-chart"
          />
        )}

        <PdfStatus data={data.summaries} />
      </div>
    </div>
  );
};
